export enum Period {
    Hourly = 'hourly',
    Daily = 'daily',
    Monthly = 'monthly',
    Yearly = 'yearly',
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/services/dtos/enums/period.enum.ts